/* Imports */
import React from "react"
import { Icon, Font, Section } from "fajny-react"

import ComponentPage from "../../components/ComponentPage"

import commonProps from "../../data/common-props"

const IconPage = () => {
    const items = [
        {
            content: <Icon src="box-solid" size={64} color="danger" />,
            code: '<Icon src="box-solid" size={64} color="danger" />',
        },
    ]

    const propsItems = [
        {
            name: "src",
            type: "String",
            required: "Yes",
        },
        {
            name: "size",
            type: "Number",
            example: "48",
            default: "24",
        },
        {
            name: "color",
            type: "String",
            example: "success",
            possible: commonProps.allColors,
            default: "currentColor",
        },
    ]

    return (
        <ComponentPage items={items} propsItems={propsItems}>
            <Section gap="small">
                <Font.H4>How to use</Font.H4>
                <Font.P>
                    Download SVG icons, and put them in the folder
                    <code>/public/icons</code>. Then you can use this component.
                </Font.P>
            </Section>
        </ComponentPage>
    )
}

export default IconPage
